import { render, staticRenderFns } from "./WinterPage.vue?vue&type=template&id=63f31230&scoped=true&"
import script from "./WinterPage.vue?vue&type=script&lang=js&"
export * from "./WinterPage.vue?vue&type=script&lang=js&"
import style0 from "./WinterPage.vue?vue&type=style&index=0&id=63f31230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f31230",
  null
  
)

export default component.exports